import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

/**
 * Background da pagina no estilo Mac/Apple — gradient sutil que comeca
 * branco puro (igual ao sidebar) e vai pra um azul muito claro nas bordas,
 * com manchas radiais da cor da marca.
 *
 * Comecar com #FFFFFF evita a "divisa" visivel entre o sidebar (branco)
 * e o conteudo da pagina.
 */
export const GlassPageBg = ({ children, ...rest }: BoxProps) => (
  <Box
    minH="100vh"
    position="relative"
    sx={{
      backgroundColor: '#FFFFFF',
      backgroundImage: `
        radial-gradient(at 12% 0%, rgba(27, 136, 245, 0.10) 0%, transparent 55%),
        radial-gradient(at 95% 30%, rgba(27, 136, 245, 0.06) 0%, transparent 50%),
        radial-gradient(at 50% 100%, rgba(27, 136, 245, 0.05) 0%, transparent 60%)
      `,
    }}
    {...rest}
  >
    {children}
  </Box>
);
